import { render, staticRenderFns } from "./bao-cao-doanh-thu-khach-hang.vue?vue&type=template&id=db4037c0&scoped=true&"
import script from "./bao-cao-doanh-thu-khach-hang.vue?vue&type=script&lang=js&"
export * from "./bao-cao-doanh-thu-khach-hang.vue?vue&type=script&lang=js&"
import style0 from "./bao-cao-doanh-thu-khach-hang.vue?vue&type=style&index=0&id=db4037c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4037c0",
  null
  
)

export default component.exports